import { useEffect, useState } from 'react';
import { getRawValue } from '../../../services/vault/vgsValue';

export default function useRawValue(token: string): string | undefined {
  const [rawValue, setRawValue] = useState<string>();
  useEffect(() => {
    async function gatherData(): Promise<void> {
      if (rawValue !== undefined) {
        return;
      }
      const retrievedRawValue = await getRawValue(token);
      setRawValue(retrievedRawValue);
    }
    gatherData();
  });
  return rawValue;
}
